import React, { FC, useState } from "react";

import Button from "../../../../../components/elements/Button";
import EditCampaignDetailsModal from "./EditCampaignDetailsModal";
import { BrandgenCampaignPool } from "../../../../../types/campaignTypes";

type EditCampaignDetailsButtonProps = {
  campaignToEdit: BrandgenCampaignPool;
  fetchAndSetCampaings: () => void;
};

const EditCampaignDetailsButton: FC<EditCampaignDetailsButtonProps> = ({ campaignToEdit, fetchAndSetCampaings }) => {
  const [isEditCampaignModalOpen, setIsEditCampaignModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsEditCampaignModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsEditCampaignModalOpen(false);
  };

  return (
    <>
      <Button onClick={handleOpenModal} variant="contained">
        Edit Campaign Details
      </Button>
      <EditCampaignDetailsModal
        isOpen={isEditCampaignModalOpen}
        handleClose={handleCloseModal}
        campaignToEdit={campaignToEdit}
        fetchAndSetCampaings={fetchAndSetCampaings}
      />
    </>
  );
};

export default EditCampaignDetailsButton;
